import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';
import { Product, ProductPrice } from '../../types/product';

const api = generateApiClient();

export const getOrdersApi = async (query?: any): Promise<any> => {
  try {
    api.setHeader('Accept', `application/eshop.content.api.json`);
    const response: ApiResponse<any> = await api.get(`orders${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createOrderApi = async (product: Product): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`orders`, product);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateOrderApi = async (id: number, product: Product): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`orders/${id}`, product);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getOrderByIdApi = async (id: number): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`orders/${id}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
export const createOrderPaymentRequestApi = async (id: number, paymentRequest: PaymentRequest): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`orders/${id}/payment-requests`, paymentRequest);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateOrderPaymentRequestApi = async (
  id: number,
  paymentRequestId: number,
  paymentRequest: PaymentRequest,
): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`orders/${id}/payment-requests/${paymentRequestId}`, paymentRequest);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getOrderPaymentRequestsApi = async (id: number): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`orders/${id}/payment-requests`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
